import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NationalitiesService {
  private iContactAdminURL: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iContactAdminURL = config.apiContactAdminBaseUrl;
  }

  public fetchNationalities(): Observable<string[]> {
    return this.http.get<string[]>(`${this.iContactAdminURL}/Global/nationalites`);
  }
}
